import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';

import API from 'app/API';

const useStyles = makeStyles()((theme) => ({
    speller: {
        margin: '0 auto'
    },
    container: {
        padding: '0 36px',
        color: 'grey',
        textAlign: 'center'
    },
    query: {
        cursor: 'pointer',
        margin: '0 8px',
        fontSize: '18px',
        color: theme.palette.primary.main,
        '&:hover': {
            textDecoration: 'underline'
        }
    }
}));

const Speller = ({ show, query, onSpellClick }) => {
    const { classes } = useStyles();
    const [originalQuery, setOriginalQuery] = useState('');
    const [correctedQuery, setCorrectedQuery] = useState('');

    const castSpell = useCallback(
        (query) =>
            API.fetch(API.SPELLER, { query }).then((response) => {
                const { originalQuery, correctedQuery } = response.data;
                setCorrectedQuery(correctedQuery);
                setOriginalQuery(originalQuery);
            }),
        []
    );

    useEffect(() => {
        show && castSpell(query);
    }, [castSpell, query, show]);

    const handleSpellClick = useCallback(() => {
        onSpellClick(correctedQuery);
        setCorrectedQuery('');
        setOriginalQuery('');
    }, [correctedQuery, onSpellClick]);

    if (!show || !correctedQuery || correctedQuery === originalQuery) {
        return null;
    }

    return (
        <div className={classes.speller}>
            <div className={classes.container}>
                Did you mean
                <span className={classes.query} onClick={handleSpellClick}>
                    {correctedQuery}
                </span>
                {' ?'}
            </div>
        </div>
    );
};

Speller.propTypes = {
    show: PropTypes.bool,
    query: PropTypes.string,
    onSpellClick: PropTypes.func
};

export default Speller;
